export default {
  methods: {
    
    draw_Timeline_Week() {    
      
      let height = 36
      let timeline = this.timeline

      this.canvasTimeline = this.canvasForm
      .append('g')
      .attr('transform', `translate(${timeline.x}, ${timeline.y})`)

      this.canvasTimeline
      .append('path') // shadow
      .attr('d', `M50,${height + 4} H ${timeline.length-50} L ${timeline.length},${height + 12} H0 Z`)
      .attr('fill', `url(#shadowTimeline)`) 

      this.canvasTimeline
      .append('rect') 
      .attr('x', 0).attr('y', 0).attr('width', timeline.length).attr('height', 2)
      .attr('fill', `url(#${this.localId}_LightGray_)`).attr('opacity', .99)

      this.canvasTimeline
      .append('rect')
      .attr('x', 0).attr('y', 2).attr('width', timeline.length).attr('height', height)
      .attr('fill', `url(#${this.localId}_LightGray_)`).attr('opacity', .5)

      this.canvasTimeline
      .append('rect') 
      .attr('x', 0).attr('y', height + 1).attr('width', timeline.length).attr('height', 5)
      .attr('fill', `url(#${this.localId}_LightGray_)`)

      // Week 
      timeline.week.forEach((d,i)=> {

        this.canvasTimeline
        .append('text')
        .attr('x', timeline.scale(d.mDate))
        .attr('y', 11)
        .attr('font-size', 9).attr('fill', '#757575').attr('text-anchor', 'middle')
        .text(d.name)

        this.canvasTimeline
        .append('path')
        .attr('d', () => {
          if (i != timeline.week.length-1) return `M${timeline.scale(d.eDate)}, 2 V 11`
        })
        .attr('stroke', '#bcbcbc').attr('stroke-width', .5)

        if(d.date == timeline.cutoff) {
          this.canvasTimeline
          .append('rect')
          .attr('x',timeline.scale(d.sDate) + .5).attr('y',.5)
          .attr('width', timeline.scale(d.eDate) - timeline.scale(d.sDate)-.5).attr('height',14)
          .attr('fill','#F7BACF').attr('stroke','#bcbcbc').attr('stroke-width',0.5).attr('opacity', 0.3)   
        }
      })

      // Month 
      timeline.month.forEach((d,i)=> {
        this.canvasTimeline
        .append('text')
        .attr('x', timeline.scale(d.mDate)).attr('y', 20)
        .attr('font-size', 9).attr('fill', '#333')
        .attr('text-anchor', 'middle')
        .text(d.name.toUpperCase())

        this.canvasTimeline
        .append('path')
        .attr('stroke', '#bcbcbc').attr('stroke-width', 0.5)
        .attr('d', () => {
          if (i != timeline.month.length-1) return `M${timeline.scale(d.eDate)}, 11 V18`
        })
      })
      
      // Year 
      timeline.year.forEach((d,i)=> {
        this.canvasTimeline
        .append('text')
        .attr('x', timeline.scale(d.mDate)).attr('y', 33)
        .attr('font-size', 12).attr('fill', '#000').attr('font-weight', 500)
        .attr('text-anchor', 'middle')
        .text(d.name)

        this.canvasTimeline
        .append('path')
        .attr('stroke', '#BCBCBC').attr('stroke-width', 0.5)
        .attr('d', () => {
          if (i != timeline.year.length-1) return `M${timeline.scale(d.eDate)}, 18 V35`
        })
      })

    },
  }
}
